import React from 'react';
import parsePhoneNumber from 'libphonenumber-js';
import { useSelector, useDispatch } from 'react-redux';

import { setReceiverPhoneAndCountry, setReceiverPhoneNumber } from './receiverSlice';

export default function ContactPicker({ handleError }) {
  const allSupportedCountries = useSelector((state) => state.transferTypes.allSupportedCountries);
  const dispatch = useDispatch();

  const supported = 'contacts' in navigator && 'ContactsManager' in window;

  const handleContactPick = (res) => {
    handleError();

    let number = res[0].tel[0].split(' ').join('');
    let countryCode;

    if (number.startsWith('0')) {
      number = number.substring(1);
    }

    if (number.startsWith('+')) {
      const phoneNumberObj = parsePhoneNumber(number);

      if (phoneNumberObj && allSupportedCountries.includes(phoneNumberObj.country)) {
        number = phoneNumberObj.nationalNumber;
        countryCode = phoneNumberObj.country;
      } else {
        return handleError(
          `Check if the country and phone number are correct. We may not yet support your country.`
        );
      }
    }

    if (countryCode) {
      if (countryCode === 'AG') {
        number = number.substring(3);
      }

      dispatch(setReceiverPhoneAndCountry({ phoneNumber: number, countryCode }));
    } else {
      dispatch(setReceiverPhoneNumber(number));
    }
  };

  const contactPicker = async () => {
    try {
      const props = ['tel'];
      const opts = { multiple: false };

      const contacts = await navigator.contacts.select(props, opts);
      handleContactPick(contacts);
    } catch (ex) {
      handleError('Something went wrong. Please try again.');
    }
  };

  if (!supported) {
    return null;
  }

  return (
    <div className="select-from-contacts non-selectable" onClick={contactPicker}>
      Select from contacts
    </div>
  );
}
